(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jt-collection-hero"] && !Shopify.designMode) return;
  try {
    
  if (!window.jtCollectionSortBound) {
    window.jtCollectionSortBound = true;

    const prepareSortButton = () => {
      const button = document.querySelector('main[data-template^="collection"] .facets-toggle__button');
      if (!button) return;
      button.removeAttribute('on:click');
      button.removeAttribute('aria-haspopup');
      button.setAttribute('aria-controls', 'jt-sort-panel');
      button.setAttribute('aria-expanded', 'false');
    };

    const updateTabsHint = () => {
      const tabs = document.querySelector('.jt-collection-tabs');
      const more = document.querySelector('.jt-collection-tabs__more');
      if (!tabs || !more) return;
      const hiddenAtEnd = tabs.scrollWidth - tabs.clientWidth - Math.abs(tabs.scrollLeft);
      more.hidden = hiddenAtEnd <= 4;
    };

    const setupTabs = () => {
      const tabs = document.querySelector('.jt-collection-tabs');
      const more = document.querySelector('.jt-collection-tabs__more');
      if (!tabs) return;
      const active = tabs.querySelector('.is-active');
      if (active && tabs.scrollWidth > tabs.clientWidth) {
        tabs.scrollLeft += active.getBoundingClientRect().left + active.offsetWidth / 2 - (tabs.getBoundingClientRect().left + tabs.clientWidth / 2);
      }
      tabs.addEventListener('scroll', updateTabsHint, { passive: true });
      window.addEventListener('resize', updateTabsHint);
      more?.addEventListener('click', () => tabs.scrollBy({ left: -tabs.clientWidth * 0.6, behavior: 'smooth' }));
      updateTabsHint();
    };

    document.addEventListener('DOMContentLoaded', prepareSortButton);
    document.addEventListener('DOMContentLoaded', setupTabs);
    document.addEventListener(
      'click',
      (event) => {
        const button = event.target.closest('main[data-template^="collection"] .facets-toggle__button');
        if (!button) return;

        const panel = document.getElementById('jt-sort-panel');
        if (!panel) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        panel.hidden = !panel.hidden;
        button.setAttribute('aria-expanded', String(!panel.hidden));
      },
      true
    );

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const panel = document.getElementById('jt-sort-panel');
      const button = document.querySelector('main[data-template^="collection"] .facets-toggle__button');
      if (!panel || panel.hidden) return;
      panel.hidden = true;
      button?.setAttribute('aria-expanded', 'false');
      button?.focus();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jt-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-jt-product]').forEach((section) => {
    const slides = section.querySelector('[data-jt-slides]');
    const items = slides ? Array.from(slides.children) : [];
    const progress = section.querySelector('[data-gallery-progress]');
    const updateProgress = () => {
      if (!slides || !progress || items.length < 2) return;
      const index = Math.round(slides.scrollLeft / slides.clientWidth);
      progress.style.transform = `translateX(${index * 100}%) scaleX(${1 / items.length})`;
    };
    if (slides) {
      section.style.setProperty('--jt-media-count', Math.max(items.length, 1));
      slides.addEventListener('scroll', updateProgress, { passive: true });
      section.querySelector('[data-gallery-prev]')?.addEventListener('click', () => slides.scrollBy({ left: -slides.clientWidth, behavior: 'smooth' }));
      section.querySelector('[data-gallery-next]')?.addEventListener('click', () => slides.scrollBy({ left: slides.clientWidth, behavior: 'smooth' }));
    }

    const dialog = section.querySelector('[data-jt-zoom-dialog]');
    section.querySelector('[data-jt-zoom]')?.addEventListener('click', () => dialog?.showModal());
    section.querySelector('[data-jt-zoom-close]')?.addEventListener('click', () => dialog?.close());


    const optionSelects = Array.from(section.querySelectorAll('[data-option-select]'));
    const variantInput = section.querySelector('[data-variant-id]');
    const variantData = section.querySelector('[data-product-variants]');
    const price = section.querySelector('[data-product-price]');
    const add = section.querySelector('.jt-product__add');
    let variants = [];

    if (variantData) {
      try {
        variants = JSON.parse(variantData.textContent);
      } catch (_) {
        variants = [];
      }
    }

    const updateSelectedVariant = () => {
      if (!optionSelects.length || !variants.length) return;

      const selectedOptions = optionSelects.map((select) => select.value);
      const selectedVariant = variants.find((candidate) =>
        candidate.options.every((value, index) => String(value) === String(selectedOptions[index]))
      );
      const available = Boolean(selectedVariant && selectedVariant.available);

      if (variantInput) variantInput.value = selectedVariant ? selectedVariant.id : '';
      if (price && selectedVariant) price.textContent = selectedVariant.price;

      if (add) {
        add.disabled = !available;
        add.textContent = available ? add.dataset.addLabel : add.dataset.soldLabel;
      }

      if (selectedVariant && window.history?.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', selectedVariant.id);
        window.history.replaceState({}, '', url);
      }
    };

    optionSelects.forEach((select) => select.addEventListener('change', updateSelectedVariant));
    updateSelectedVariant();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
